var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.005 2H13.005L7.995 8.3L3.005 2ZM0.255 1.61C2.275 4.2 6.005 9 6.005 9V15C6.005 15.55 6.455 16 7.005 16H9.005C9.555 16 10.005 15.55 10.005 15V9C10.005 9 13.725 4.2 15.745 1.61C16.255 0.95 15.785 0 14.955 0H1.045C0.215 0 -0.255 0.95 0.255 1.61Z",
    fill: "#0B7340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.68e0a41310d90ae5d9246197f22b1fa3.svg";
export { ForwardRef as ReactComponent };